import {createContext} from 'react'

const AseguradorasContext = createContext()

export default AseguradorasContext